import { Component, Element, Prop, h } from '@stencil/core';

@Component({
  tag: 'lar-node-titles',
  styleUrl: 'node-titles.scss',
  scoped: true
})

export class NodeTitles {
  @Element() el!: HTMLElement;

  /**
   * Node subtitle
   */
  @Prop() subTitle?: string;
  /**
   * Node superscript title
   */
  @Prop() supTitle?: string;
  /**
   * Node main title
   */
  @Prop() mainTitle!: string;

  render() {
   return [
     <div class="node-titles">
       {this.supTitle && <h3><lar-translate t={this.supTitle} /></h3>}
       {this.mainTitle && <h2><lar-translate t={this.mainTitle} /></h2>}
       {this.subTitle && <h3><lar-translate t={this.subTitle} /></h3>}
     </div>
   ];
  }
}
